import { contentsType } from '../types';

const fundachartContents: Array<contentsType> = [
  {
    title: 'PE Standard Deviation Band',
    description:
      'Gunakan salah satu tools yang sering dipakai oleh institusi untuk melakukan valuasi saham. PE Standard Deviation Band berguna untuk mengetahui apakah saham sudah murah atau mahal berdasarkan PE Ratio historicalnya.',
    image: 'Fundachart_PE_Std_Blue.jpg',
  },
  {
    title: 'PE Price Band',
    description:
      'Pelajari tren harga saham berdasarkan harga yang sesuai dengan PE rasio saham tersebut. Liat apakah saham tersebut sudah murah atau mahal.',
    image: 'Fundachart_PE_Price_Blue.jpg',
  },
  {
    title: 'PBV Standard Deviation Band',
    description:
      'PBV Standard Deviation Band juga adalah salah satu tools yang sering digunakan oleh institusi untuk melakukan valuasi saham. Cari tahu saham sudah murah atau mahal berdasarkan PBV Ratio historicalnya.',
    image: 'Fundachart_PBV_Blue.jpg',
  },
];

export default fundachartContents;
